import _ from "lodash";
import { includesInsensitive } from "util/string";

/**
 * Filtra a lista a partir do dicionário de filtros especificado.
 * Deve satisfazer todos os filtros simultaneamente.
 *
 * 'filters' é uma lista de objetos no formato:
 * {
 *     value: String,
 *     databaseFilter: Boolean,
 *     doFilter: function
 * }
 */
export function filterList(list, filters) {
    if (_.isEmpty(filters)) {
        return list;
    }

    return list.filter((item) => {
        for (const key in filters) {
            const fieldValue = _.get(item, key);

            if (!filters[key].databaseFilter && !includesInsensitive(fieldValue, filters[key].value)) {
                return false;
            }
        }

        return true;
    });
}

/**
 * Filtra a lista a partir do dicionário de filtros especificado.
 * Deve satisfazer pelo menos um dos filtros.
 *
 * 'filters' é uma lista de objetos no formato:
 * {
 *     value: String,
 *     databaseFilter: Boolean,
 *     doFilter: function
 * }
 */
export function filterGroupedList(list, filters) {
    if (_.isEmpty(filters)) return list

    let filteredGroupedList = list.map((sub) => {
        for (const key in filters) {
            if (key === "subheader") { // percorre a lista de grupos
                let isGroupMatch = !filters[key].databaseFilter && includesInsensitive(_.get(sub, key), filters[key].value)
                if (isGroupMatch) return sub
            }
            else { // percorrer a lista de itens de cada grupo (itens agrupados)
                let filteredItems = sub.items.filter(item => {
                    let isItemMatch = !filters[key].databaseFilter && includesInsensitive(_.get(item, key), filters[key].value)
                    if (isItemMatch) return true
                    else return false
                })

                if (filteredItems.length > 0) return { subheader: sub.subheader, items: filteredItems }
            }
        }

        return null
    }).filter(sub => sub !== null)

    return filteredGroupedList
}

export function filterListAny(list, filters) {
    if (_.isEmpty(filters)) {
        return list;
    }

    return list.filter((item) => {
        for (const key in filters) {
            const fieldValue = _.get(item, key);

            if (!filters[key].databaseFilter && includesInsensitive(fieldValue, filters[key].value)) {
                return true;
            }
        }

        return false;
    });
}

/**
 * TODO: comentar
 * @param {*} collection
 * @param {*} filters
 * @returns
 */
export function filterCollection(collection, filters) {
    for (const key in filters) {
        const filter = filters[key];

        if (filter.databaseFilter) {
            if (filter.doFilter) {
                collection = filter.doFilter(collection, filter);
            } else {
                collection = collection.where(key, "==", filter.value);
            }
        }
    }

    return collection;
}
